import React, { Component } from 'react';

import { Parse } from 'parse';

import moment from 'moment';

import Add from 'material-ui/svg-icons/content/add';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import { List, ListItem } from 'material-ui/List';
import MenuItem from 'material-ui/MenuItem';

import * as Colors from '../../styles/colors';
import * as ParseService from '../../services/parse';
import MarkerText from '../../components/MarkerText';
import SemesterAddDetail from './components/SemesterAddDetail';

class SemesterList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      childItems: {},
      showSemesterAdd: false,
    };
  }

  fetchCourses(i, semester, childItems, callback) {
    var coursesQuery = semester.get('courses').query();
    coursesQuery.include('grade');
    coursesQuery.include('grade.gradeSettings');
    coursesQuery.include('syllabus');
    coursesQuery.find({
      success: function(results) {
        childItems[semester.id] = results;
        callback(i);
      },
      error: function(err) {
        console.log("Error " + err);
      }
    });
  }

  componentWillMount() {
    this.fetchSemesters();
  }

  handleSemesterAdd = (result) => {
    this.fetchSemesters();

    this.setState({showSemesterAdd: false});
  }

  fetchSemesters() {
    const that = this;

    ParseService.findSemesters().then(
      function(results) {
        var childItems = {};

        for (var i = 0; i < results.length; i++) {
          var semester = results[i];
          that.fetchCourses(i, semester, childItems, function(i) {
            if (i === (results.length - 1)) {
              that.setState({items: results, childItems: childItems});
            }
          });
        }
      },
      function(err) {
        console.log("Failed to fetch Semesters " + err);
      });
  }

  render() {
    const items = this.state.items;
    const childItems = this.state.childItems;

    const markerTextStyle = {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      margin: '0px',
    };

    const dateFormat = 'll';

    return (
      <div className="scene-leading-box">
        
        <div className='action-bar'>
          <div className='action-bar__actions'>
            <IconMenu
              animated={false}
              desktop={true}
              iconButtonElement={<IconButton><Add color={Colors.peterRiver}/></IconButton>}
              anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
              targetOrigin={{horizontal: 'middle', vertical: 'top'}} >
              
              <MenuItem primaryText="New Semester..." onClick={() => this.setState({showSemesterAdd: true})} />
              { 
                // <MenuItem primaryText="New Course..." /> 
              }

            </IconMenu>
          </div>

          <div className='action-bar__title'>
            Semesters
          </div>
        </div>

        <div className="list-content">
          <div className='list-content__list'>
            <List>
              {items.map((item) =>
                <ListItem
                  key={item.id}
                  value={item.id}
                  primaryText={item.get('title')}
                  secondaryText={moment(item.get('startDate')).format(dateFormat) + " - " + moment(item.get('endDate')).format(dateFormat)}
                  primaryTogglesNestedList={true}
                  nestedItems={childItems[item.id] != null ? childItems[item.id].map((childItem) =>
                      <ListItem
                        key={childItem.id}
                        value={childItem.id}
                        primaryText={<MarkerText style={markerTextStyle} text={childItem.get('title')} color={childItem.get('color')} />}
                        onClick={() => this.props.onChildItemSelected(childItem)}
                      />
                    ) : []}
                />
              )}
            </List>
          </div>
        </div>

        { this.state.showSemesterAdd ? (
          <SemesterAddDetail 
            onSave={this.handleSemesterAdd}
            onCancel={(result) => this.setState({showSemesterAdd: false})} />
        ) : null }
      </div>
    );

  }

}

export default SemesterList;



// WEBPACK FOOTER //
// ./src/scenes/Organizer/SemesterList.js